
export const _review = () => {
	const reviews = document.querySelector(".s-reviews");
	const requiredText = document.querySelector(".yotpo-mandatory-explain");
	const labelTexts = document.querySelectorAll(".y-label");
	const inputs = document.querySelectorAll(".y-input");

	if ( reviews ) {
		requiredText.style.display = "none";
		labelTexts[0].style.display = "none";
		labelTexts[1].innerHTML = "How Would You Rate Prenup Planner?";
		labelTexts[2].innerHTML = "Review Title";
		labelTexts[5].innerHTML = "Your Name";

		for (let i = 0; i < 7; i++) {
			labelTexts[i].classList.add("y-label--custom");
		}

		for (let i = 0; i < 4; i++) {
			inputs[i].classList.add("y-input--custom");
		}
	}
}
